import React, { Component } from 'react';
import { HashRouter, Redirect, Route, Switch, BrowserRouter } from 'react-router-dom';
import './scss/style.scss';
import 'antd/dist/antd.css';
import TokenPage from './pages/token';
import First from './pages/first';
import LoginSuccess from './pages/loginSuccess';
import Logout from './pages/loginSuccess/logout';
// import { BrowserRouter } from 'react-router-dom/cjs/react-router-dom.min';

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const TheLayout = React.lazy(() => import('./containers/TheLayout'));

// Login
const Login = React.lazy(() => import('./pages/login/Login'));
const LoginMoac = React.lazy(() => import('./pages/login/LoginMoac'));
const Register = React.lazy(() => import('./pages/register/Register'));

class App extends Component {


  render() {
    return (
      <div className="local-font">
        <BrowserRouter basename="/">
          <React.Suspense fallback={loading}>
            <Switch>
              <Route exact path="/" render={(props) => <LoginMoac {...props} />} />
              <Route path="/loginsuccess" render={(props) => <LoginSuccess {...props} />} />
              <Route path="/logout" render={(props) => <First {...props} />} />
              <Route path="/home" name="Home" render={props => <TheLayout {...props} />} />
              <Route exact path="/login" name="Login Page" render={props => <LoginMoac {...props} />} />
              <Route exact path="/register" name="Register Page" render={props => <Register {...props} />} />
              <Route exact path="/token" name="Token Page" render={props => <TokenPage {...props} />} />
            </Switch>
          </React.Suspense>
        </BrowserRouter>
      </div>

    );
  }
}

export default App;
